import { api } from './api';

export async function rephrasePrompt(raw_prompt: string): Promise<{ prompt: string; credits_remaining?: number }> {
  const { data } = await api.post('/api/v1/rephrase', { raw_prompt }, { timeout: 15_000 });
  return data;
}
